// src/core/plugins/vue-i18n.js
import { createI18n } from "vue-i18n";

// Localisation language list
import { locale as en } from "@/core/config/i18n/en";
import { locale as fa } from "@/core/config/i18n/fa";

let messages = { en, fa };

// get current selected language
const lang = localStorage.getItem("language") || "fa";

const i18n = createI18n({
  legacy: true, // keep $t(...) compatibilty
  locale: lang,
  fallbackLocale: "fa",
  messages,
});

export default i18n;

